<ng-container *ngIf="isGridView; else listTile">
<div class="timeline-tile-mode timeline-tile-mode--grid">
  <div class="timeline-grid-tile" [class.timeline-grid-tile--natural]="shareTargetEvent"
       [style.aspect-ratio]="gridAspectRatio"
       (pointerdown)="onGridTileIntent()" (click)="onGridTileClick($event)">
    <ng-container *ngIf="post?.isPlaceholder">
      <p-skeleton width="100%" height="100%"></p-skeleton>
    </ng-container>
    <ng-container *ngIf="!post?.isPlaceholder">
      <ng-container *ngIf="shouldShowLocalProcessingPreview(); else gridMediaSource">
        <div class="media-view-placeholder" *ngIf="!isGridImageLoaded(post.localThumbnailUri)"></div>
        <img #gridImage class="timeline-grid-tile__image" [style.object-fit]="shareTargetEvent ? 'contain' : null" [src]="isGridMediaDeferred ? '' : resolveGridImageSource(post.localThumbnailUri)" alt="local media preview"
             [attr.data-grid-image-src]="post.localThumbnailUri || null"
             [attr.loading]="getGridImageLoading()"
             decoding="async"
             [style.visibility]="isGridImageLoaded(post.localThumbnailUri) ? 'visible' : 'hidden'"
             (load)="onGridImageLoaded(post.localThumbnailUri, gridImage)"
             (error)="onGridImageError()">
        <div class="local-processing-overlay width-100 height-100 flex justify-content-center align-items-center" *ngIf="shouldShowLocalProcessingLoader()">
          <app-spinner [inline]="true" size="2rem"></app-spinner>
        </div>
      </ng-container>
      <ng-template #gridMediaSource>
        <ng-container *ngIf="shouldShowProcessingPlaceholder(); else gridContent">
          <p-skeleton width="100%" height="100%"></p-skeleton>
          <div class="local-processing-overlay width-100 height-100 flex justify-content-center align-items-center">
            <app-spinner [inline]="true" size="2rem"></app-spinner>
          </div>
        </ng-container>
        <ng-template #gridContent>
        <ng-container *ngIf="post?.media?.length; else gridEmpty">
          <p-skeleton *ngIf="getGridThumbnailSource() === 'none'" width="100%" height="100%"></p-skeleton>
          <ng-container *ngIf="getGridThumbnailSource() !== 'none'">
            <ng-container *ngIf="!isGridMediaDeferred">
            <ng-container *ngIf="((getGridThumbnail() | offlineMedia:'image' | async) || '') as gridImageSrc">
              <div class="media-view-placeholder" *ngIf="!isGridImageLoaded(gridImageSrc)"></div>
              <img #gridImage alt="media thumbnail" class="timeline-grid-tile__image" [style.object-fit]="shareTargetEvent ? 'contain' : null"
                   [src]="resolveGridImageSource(gridImageSrc)"
                   [attr.data-grid-image-src]="gridImageSrc"
                   [attr.loading]="getGridImageLoading()"
                   decoding="async"
                   [style.visibility]="isGridImageLoaded(gridImageSrc) ? 'visible' : 'hidden'"
                   (load)="onGridImageLoaded(gridImageSrc, gridImage)"
                   (error)="onGridImageError()" />
              <div class="local-processing-overlay width-100 height-100 flex justify-content-center align-items-center"
                   *ngIf="!isGridImageLoaded(gridImageSrc) && shouldShowProcessingPlaceholder()">
                <app-spinner [inline]="true" size="2rem"></app-spinner>
              </div>
            </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        </ng-template>
      </ng-template>
      <ng-template #gridEmpty>
        <p-skeleton width="100%" height="100%"></p-skeleton>
        <div class="local-processing-overlay width-100 height-100 flex justify-content-center align-items-center"
             *ngIf="shouldShowProcessingPlaceholder()">
          <app-spinner [inline]="true" size="2rem"></app-spinner>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>

</ng-container>

<!--
  Keep grid and list mutually exclusive. CSS-hiding the inactive branch still
  instantiated its media views, including hidden video elements in Media.
-->
<ng-template #listTile>
<div class="timeline-tile-mode timeline-tile-mode--list">
<p-card *ngIf="post?.isPlaceholder" [style]="{width: '100%'}" class="timeline-tile" styleClass="mb-1">
  <ng-template pTemplate="header">
    <div class="grid grid-nogutter">
      <div class="pt-2 col flex column-gap-2">
        <p-skeleton shape="circle" size="36px"></p-skeleton>
        <div>
          <p-skeleton width="15rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="grid grid-nogutter">
    <div class="col-12 ">
      <p-skeleton width="100%" styleClass="mb-1"></p-skeleton>
      <p-skeleton width="95%" styleClass="mb-1"></p-skeleton>
      <p-skeleton width="75%" styleClass="mb-2"></p-skeleton>
      <p-skeleton width="4rem" styleClass="mb-3"></p-skeleton>
      <div class="grid post-media"
        [ngClass]="{'one-item': skeletonRandomNumber === 1, 'three-items': skeletonRandomNumber === 3}">
        <ng-container [ngSwitch]="skeletonRandomNumber">
          <ng-container *ngSwitchCase="1">
            <div class="col-12 p-0">
              <p-skeleton width="100%" height="200px"></p-skeleton>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="2">
            <div class="col-6 p-0">
              <p-skeleton width="100%" height="150px"></p-skeleton>
            </div>
            <div class="col-6 p-0">
              <p-skeleton width="100%" height="150px"></p-skeleton>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="3">
            <div class="col-12 p-0">
              <p-skeleton width="100%" height="200px"></p-skeleton>
            </div>
            <div *ngFor="let item of [1,2]" class="col-6 p-0">
              <p-skeleton width="100%" height="150px"></p-skeleton>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="4">
            <div *ngFor="let item of [1,2,3,4]; let i = index" class="col-6 p-0">
              <p-skeleton width="100%" height="150px"></p-skeleton>
            </div>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="col-6 p-0">
              <p-skeleton width="100%" height="150px"></p-skeleton>
            </div>
            <div class="col-6 p-0">
              <p-skeleton width="100%" height="150px"></p-skeleton>
            </div>
            <div *ngFor="let item of [1,2,3]" class="col-4 p-0">
              <p-skeleton width="100%" height="150px"></p-skeleton>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="grid">
      <div class="col-12 inline-flex justify-content-end" style="gap: 20px">
        <span class="link">
          <p-skeleton width="4rem" styleClass="mb-2"></p-skeleton>
        </span>
        <span class="link">
          <p-skeleton width="4rem" styleClass="mb-2"></p-skeleton>
        </span>
        <span class="link">
          <p-skeleton width="4rem" styleClass="mb-2"></p-skeleton>
        </span>
      </div>
    </div>
    <hr class="post-divider">
    <div class="grid mx-0">
      <div class="col-12 flex justify-content-center p-0 m-0 mb-1 mt-1 pt-1">
        <div class="p-buttonset" style="width: 100%">
          <button pButton type="button" [label]="'common.like_it' | translate"
            class="p-button-text p-button-rounded p-button-plain text-center justify-content-center flex-auto"
            style="width: 33.33%; font-size: 0.8em" icon="pi pi-thumbs-up" [disabled]="true"></button>
          <button pButton type="button" [label]="'common.comment' | translate | ucfirst"
            class="p-button-text p-button-rounded p-button-plain text-center justify-content-center"
            style="width: 33.33%; font-size: 0.8em" icon="pi pi-comments" [disabled]="true"></button>
          <button pButton type="button" [label]="'common.share' | translate"
            class="p-button-text p-button-rounded p-button-plain text-center justify-content-center"
            style="width: 33.33%; font-size: 0.8em" icon="pi pi-share-alt" [disabled]="true"></button>
        </div>
      </div>
    </div>
  </ng-template>
</p-card>

<p-menu #shareMenu [popup]="true" [model]="shareMenuItems" appendTo="body"></p-menu>

<p-card *ngIf="!post?.isPlaceholder" [style]="{width: '100%'}" class="timeline-tile" styleClass="mb-1">
  <ng-template pTemplate="header">
    <div class="grid grid-nogutter flex-nowrap align-items-start">
      <div class="pt-2 col flex column-gap-2 min-w-0">
        <app-post-source-header [post]="post"
                                [showShareState]="post.shareType === 'post' && !!post.shareId">
        </app-post-source-header>
      </div>
      <div class="col-fixed flex flex-shrink-0 justify-content-end">
        <ng-container *ngIf="canOpenPostContextMenu">
          <app-end-cap icon="pi pi-ellipsis-h"
            [ariaLabel]="'common.options' | translate"
            [pointerClass]="'p-button-rounded p-button-text p-button-icon-only p-button-primary'"
            (onClickTrigger)="emitPostContextMenuOpen(post)">
          </app-end-cap>
        </ng-container>
      </div>
    </div>
  </ng-template>
  <div class="grid grid-nogutter">
    <div class="col-12 ">
      <div *ngIf="!isTextExpanded">
        <div [innerHTML]="(post.content | truncateOnWord: 500: post.content.length > 500 ? '...' : '') | sanitizeHtml">
        </div>
        <a *ngIf="post.content.length > 500" class="pl-2" style="cursor: pointer" (click)="isTextExpanded = true">{{
          'common.more' | translate }}</a>
      </div>
      <div *ngIf="isTextExpanded">
        <div [innerHTML]="post.content | sanitizeHtml"></div>
        <a class="pl-2" style="cursor: pointer" (click)="isTextExpanded = false">{{ 'common.less' | translate }}</a>
      </div>
      <app-share-card *ngIf="post.shareCard"
                      class="block mt-3"
                      [card]="post.shareCard"
                      [currentUser]="currentUser">
      </app-share-card>
      <div *ngIf="hasMediaOrLocalPreview()" class="mt-3">
        <ng-container *ngIf="shouldShowLocalProcessingPreview(); else mediaCollection">
          <div class="grid post-media"
               [ngClass]="{
                 'one-item': getDisplayMediaCount() === 1,
                 'three-items': getDisplayMediaCount() === 3,
                 'post-media--with-video': getDisplayMediaCount() > 1 && hasDisplayVideoMedia()
               }">
            <div class="col-12 p-0 local-processing-preview-wrap relative">
              <app-media-view #object *ngIf="getLocalPreviewMediaObject() as localPreviewMediaObject"
                [mediaObject]="localPreviewMediaObject" [ratio]="1" [priority]="index < 3" [prewarm]="false" [thumbnailOnly]="isSwipePreview" [deferLoading]="isGridMediaDeferred"></app-media-view>
              <div class="local-processing-overlay"
                   *ngIf="shouldShowLocalProcessingLoader()">
                <app-spinner [inline]="true" size="2rem"></app-spinner>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #mediaCollection>
        <ng-container *ngIf="shouldShowProcessingPlaceholder(); else readyMediaCollection">
          <div class="grid post-media"
               [ngClass]="{
                 'one-item': getDisplayMediaCount() === 1,
                 'three-items': getDisplayMediaCount() === 3,
                 'post-media--with-video': getDisplayMediaCount() > 1 && hasDisplayVideoMedia()
               }">
            <ng-container [ngSwitch]="post.media?.length || 1">
              <ng-container *ngSwitchCase="1">
                <div class="col-12 p-0 local-processing-preview-wrap relative loading-media-slot"
                     [appAspectRatio]="getLoadingMediaRatio(1, 0)">
                  <p-skeleton width="100%" height="100%"></p-skeleton>
                  <div class="local-processing-overlay absolute width-100 height-100 -8 flex justify-content-center align-items-center">
                    <app-spinner [inline]="true" size="2rem"></app-spinner>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="2">
                <div *ngFor="let _ of [0,1]; let i = index" class="col-6 p-0 relative loading-media-slot"
                     [appAspectRatio]="getLoadingMediaRatio(2, i)">
                  <p-skeleton width="100%" height="100%"></p-skeleton>
                  <div class="local-processing-overlay absolute width-100 height-100 -8 flex justify-content-center align-items-center">
                    <app-spinner [inline]="true" size="2rem" *ngIf="i === 0"></app-spinner>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="3">
                <div class="col-12 p-0 relative loading-media-slot"
                     [appAspectRatio]="getLoadingMediaRatio(3, 0)">
                  <p-skeleton width="100%" height="100%"></p-skeleton>
                  <div class="local-processing-overlay absolute width-100 height-100 -8 flex justify-content-center align-items-center">
                    <app-spinner [inline]="true" size="2rem"></app-spinner>
                  </div>
                </div>
                <div *ngFor="let _ of [0,1]; let i = index" class="col-6 p-0 relative loading-media-slot"
                     [appAspectRatio]="getLoadingMediaRatio(3, i + 1)">
                  <p-skeleton width="100%" height="100%"></p-skeleton>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="4">
                <div *ngFor="let _ of [0,1,2,3]; let i = index" class="col-6 p-0 relative loading-media-slot"
                     [appAspectRatio]="getLoadingMediaRatio(4, i)">
                  <p-skeleton width="100%" height="100%"></p-skeleton>
                  <div class="local-processing-overlay absolute width-100 height-100 -8 flex justify-content-center align-items-center"
                       *ngIf="i === 0">
                    <app-spinner [inline]="true" size="2rem"></app-spinner>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div *ngFor="let _ of [0,1,2,3,4]; let i = index"
                     class="p-0 relative loading-media-slot"
                     [ngClass]="i < 2 ? 'col-6' : 'col-4'"
                     [appAspectRatio]="getLoadingMediaRatio(5, i)">
                  <p-skeleton width="100%" height="100%"></p-skeleton>
                  <div class="local-processing-overlay absolute width-100 height-100 -8 flex justify-content-center align-items-center"
                       *ngIf="i === 0">
                    <app-spinner [inline]="true" size="2rem"></app-spinner>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
        <ng-template #readyMediaCollection>
          <app-post-media-grid [post]="post" [containImages]="!!shareTargetEvent"
                               [currentUser]="currentUser"
                               [fetchDeleted]="fetchDeleted"
                               [galleryPosts]="galleryPosts"
                               [galleryPostSequence$]="galleryPostSequence$"
                               [galleryLoadNextPostPage]="galleryLoadNextPostPage"
                               [galleryHasNextPostPage]="galleryHasNextPostPage"
                               [galleryPostPageSize]="galleryPostPageSize"
                               [galleryPrefetchAtPostIndex]="galleryPrefetchAtPostIndex"
                               [interactive]="!isSwipePreview"
                               [thumbnailOnly]="isSwipePreview"
                               [deferLoading]="isGridMediaDeferred"
                               [priority]="index < 3">
          </app-post-media-grid>
        </ng-template>
        </ng-template>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="grid flex justify-content-end">
      <div class="col-fixed flex justify-content-end align-items-center" style="gap: 20px">
        <span *ngIf="post.reactionsCount" class="link inline-flex align-items-center" style="gap: 5px">
          <app-social-reactions-bar [reactions]="post.reactions" (click)="openSocialModal($event, post)">
          </app-social-reactions-bar>
          <a (click)="openSocialModal($event, post)">
            {{ ('common.likes' | translate) + ': ' + post.reactionsCount }}
          </a>
        </span>
        <span *ngIf="post.commentsCount" class="link">
          <a (click)="onCommentBoxOpen(post)">{{ ('common.comments' | translate) + ': ' + post.commentsCount }}</a>
        </span>
        <span *ngIf="post.sharesCount" class="link">
          <a>{{ ('common.shares' | translate) + ': ' + post.sharesCount }}</a>
        </span>
      </div>
    </div>
    <hr class="post-divider">
    <div class="grid mx-0">
      <div class="col-12 flex justify-content-center p-0 m-0 mb-1 mt-1 pt-1">
        <div class="p-button-group" style="width: 100%; position: relative">
          <app-speed-dial #tileSpeedDial [model]="items" direction="right"></app-speed-dial>
          <button *ngIf="post.currentUserReaction && post.currentUserReaction.reactedWith !== ReactedWithEnum.THUMBS_UP"
            pButton type="button"
            class="p-button-text p-button-rounded text-center justify-content-center align-items-center flex-auto"
            [ngClass]="{'p-button-plain': !post.currentUserReaction, 'p-button-primary': post.currentUserReaction}"
            style="width: 33.33%; font-size: 0.8em; max-height: 32px" ngxLongPress2
            (onLongPress)="toggleReactionBtn($event, post, ReactionTypeEnum.POST_REACTION, tileSpeedDial)"
            (click)="toggleThumbsUp($event, post, ReactionTypeEnum.POST_REACTION, tileSpeedDial)" (contextmenu)="false">
            <ngx-emoji [emoji]="post.currentUserReaction.reactedWith|reactionClassMap" size="14"></ngx-emoji><span
              class="ml-2">{{('common.reaction.' +
              post.currentUserReaction.reactedWith.toLowerCase())|translate}}</span>
          </button>
          <button
            *ngIf="!post.currentUserReaction || post.currentUserReaction.reactedWith === ReactedWithEnum.THUMBS_UP"
            pButton type="button"
            [label]="(post.currentUserReaction ? 'common.reaction.thumbs_up' : 'common.like_it') | translate|translateSelector:  'c'"
            class="p-button-text p-button-rounded text-center justify-content-center flex-auto"
            [ngClass]="{'p-button-plain': !post.currentUserReaction, 'p-button-primary': post.currentUserReaction}"
            style="width: 33.33%; font-size: 0.8em" icon="pi pi-thumbs-up" ngxLongPress2
            (onLongPress)="toggleReactionBtn($event, post, ReactionTypeEnum.POST_REACTION, tileSpeedDial)"
            (click)="toggleThumbsUp($event, post, ReactionTypeEnum.POST_REACTION, tileSpeedDial)"
            (contextmenu)="false"></button>
          <button pButton type="button" [label]="'common.comment' | translate | ucfirst"
            (click)="onCommentBoxOpen(post)"
            class="p-button-text p-button-rounded p-button-plain text-center justify-content-center"
            style="width: 33.33%; font-size: 0.8em" icon="pi pi-comments"></button>
          <button pButton type="button" [label]="'common.share' | translate"
            class="p-button-text p-button-rounded p-button-plain text-center justify-content-center"
            style="width: 33.33%; font-size: 0.8em" (click)="openShareMenu($event)" icon="pi pi-share-alt"></button>
        </div>
      </div>
    </div>
    <app-qr-dialog [(visible)]="qrDialogVisible" [data]="qrDialogData"></app-qr-dialog>
    <ng-container *ngIf="isCommentBoxOpened && !isMobileView">
      <hr class="post-divider">
      <div class="grid mx-0">
        <div class="col-12 py-3 px-0 m-0 mt-1 pt-1">
          <app-social-input [typingChannel]="post?.id ? 'typing_comments:' + post.id : null" (submitted)="onCommentSubmit($event, post)"
            [imageOnly]="true" [allowEmptySubmit]="true"
            [label]="'common.write_something' | translate"></app-social-input>
        </div>
        <div class="col-12 p-0 m-0">
          <ng-container *ngIf="post.commentsCount && !commentBoxLoaded">
            <p-skeleton styleClass="mb-2" borderRadius="16px"></p-skeleton>
            <p-skeleton width="10rem" styleClass="mb-2" borderRadius="16px"></p-skeleton>
            <p-skeleton width="5rem" styleClass="mb-2" borderRadius="16px"></p-skeleton>
            <p-skeleton height="2rem" styleClass="mb-2" borderRadius="16px"></p-skeleton>
            <p-skeleton width="10rem" styleClass="mb-3" height="4rem" borderRadius="16px"></p-skeleton>
          </ng-container>
          <ng-container *ngIf="comments.length && commentBoxLoaded">
            <div *ngIf="comments.length > 1" class="inline-flex justify-content-start" style="width: 100%; gap: 20px;">
              <a *ngIf="!isThreadListOpened" (click)="toggleThreadList()">
                {{ 'common.show_all_comments' | translate }} ({{ comments.length }})</a>
              <a *ngIf="isThreadListOpened" (click)="toggleThreadList()">{{ 'common.hide_comments' | translate }}</a>
            </div>
            <ul class="comment thread mb-0">
              <li *ngFor="let comment of comments.slice(0, isThreadListOpened ? comments.length : 1)" class="mb-2">
                <div class="grid grid-nogutter">
                  <div class="col-12 inline-flex">
                    <a [routerLink]="comment.author?.slug ? ['/' + comment.author.slug, 'garage'] : null" style="height: 36px">
                      <app-thumbnail classList="thumbnail-inline-block mr-2" size="md" [circle]="true"
                        [imgSrc]="comment.author.avatar | mediaObject"></app-thumbnail>
                    </a>
                    <div class="grid grid-nogutter" style="width: 100%">
                      <div class="col-11">
                        <a [routerLink]="comment.author?.slug ? ['/' + comment.author.slug, 'garage'] : null">{{ comment.author.username }}</a>
                        <span class="block" [innerHTML]="comment.content | sanitizeHtml"></span>
                        <app-comment-media [media]="comment.media"></app-comment-media>
                      </div>
                      <div class="col-1 flex justify-content-end">
                        <app-end-cap *ngxPermissionsOnly="[comment.author | ownerRole]" icon="pi pi-ellipsis-h"
                          [pointerClass]="'p-button-rounded p-button-text p-button-icon-only p-button-primary'"
                          (onClickTrigger)="emitCommentContextMenuOpen(comment)">
                        </app-end-cap>
                      </div>
                      <div *ngIf="comment.responses.length > 1" class="col-12 inline-flex justify-content-start mb-2"
                        style="width: 100%; gap: 20px;">
                        <a *ngIf="!isItemOpened(isThreadCommentListOpened, comment)"
                          (click)="toggleThreadCommentsMap(comment)">{{ 'common.show_all_comments' | translate }}
                          ({{ comment.responses.length }})</a>
                        <a *ngIf="isItemOpened(isThreadCommentListOpened, comment)"
                          (click)="toggleThreadCommentsMap(comment)">{{ 'common.hide_comments' | translate }}</a>
                      </div>
                      <div class="col-12 inline-flex justify-content-start  mb-2" style="width: 100%; gap: 20px;">
                        <a>{{ comment.createdAt | dateAgo }}</a>
                        <app-speed-dial #commentSpeedDial [model]="items" direction="right"></app-speed-dial>
                        <a ngxLongPress2
                          (onLongPress)="toggleReactionBtn($event, comment, ReactionTypeEnum.COMMENT_REACTION, commentSpeedDial)"
                          (click)="toggleThumbsUp($event, comment, ReactionTypeEnum.COMMENT_REACTION, commentSpeedDial)"
                          (contextmenu)="false">
                          <span *ngIf="comment.currentUserReaction" class="inline-flex align-items-center">
                            <span (click)="openSocialModal($event, comment)"
                              class="mr-2">{{comment.reactions.length}}</span>
                            <ngx-emoji [emoji]="comment.currentUserReaction.reactedWith|reactionClassMap"
                              size="12.8"></ngx-emoji>
                          </span>
                          <span *ngIf="!comment.currentUserReaction">{{ 'common.like' | translate }}</span>
                        </a>
                        <a (click)="toggleReplyBooleanMap(comment, comment)">
                          {{ 'common.reply' | translate }}</a>
                      </div>
                      <ul *ngIf="comment.responses.length" class="col-12 comment">
                        <li
                          *ngFor="let reply of comment.responses.slice(isItemOpened(isThreadCommentListOpened, comment) ? 0 : comment.responses.length -1, comment.responses.length)">
                          <div class="grid grid-nogutter">
                            <div class="col-12 inline-flex">
                              <a [routerLink]="reply.author?.slug ? ['/' + reply.author.slug, 'garage'] : null" style="height: 36px">
                                <app-thumbnail classList="thumbnail-inline-block mr-2" size="md" [circle]="true"
                                  [imgSrc]="reply.author.avatar | mediaObject"></app-thumbnail>
                              </a>
                              <div class="grid grid-nogutter" style="width: 100%">
                                <div class="col-11">
                                  <a [routerLink]="reply.author?.slug ? ['/' + reply.author.slug, 'garage'] : null">{{ reply.author.username }}</a>
                                  <span class="block" [innerHTML]="reply.content | sanitizeHtml"></span>
                                  <app-comment-media [media]="reply.media"></app-comment-media>
                                </div>
                                <div class="col-1 flex justify-content-end">
                                  <app-end-cap *ngxPermissionsOnly="[reply.author | ownerRole]" icon="pi pi-ellipsis-h"
                                    [pointerClass]="'p-button-rounded p-button-text p-button-icon-only p-button-primary'"
                                    (onClickTrigger)="emitCommentContextMenuOpen(reply)">
                                  </app-end-cap>
                                </div>
                                <div class="col-12 inline-flex justify-content-start mb-2"
                                  style="width: 100%; gap: 20px;">
                                  <a>{{ reply.createdAt | dateAgo }}</a>
                                  <app-speed-dial #replySpeedDial [model]="items" direction="right"></app-speed-dial>
                                  <a ngxLongPress2
                                    (onLongPress)="toggleReactionBtn($event, reply, ReactionTypeEnum.COMMENT_REACTION, replySpeedDial)"
                                    (click)="toggleThumbsUp($event, reply, ReactionTypeEnum.COMMENT_REACTION, replySpeedDial)"
                                    (contextmenu)="false">
                                    <span *ngIf="reply.currentUserReaction" class="inline-flex align-items-center">
                                      <span (click)="openSocialModal($event, reply)"
                                        class="mr-2">{{reply.reactions.length}}</span>
                                      <ngx-emoji [emoji]="reply.currentUserReaction.reactedWith|reactionClassMap"
                                        size="12.8"></ngx-emoji>
                                    </span>
                                    <span *ngIf="!reply.currentUserReaction">{{ 'common.like' | translate }}</span>
                                  </a>
                                  <a (click)="toggleReplyBooleanMap(comment, reply)">{{ 'common.reply' | translate }}</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <div *ngIf="isItemOpened(isThreadCommentInputOpened, comment)" class="col-12">
                        <app-social-input [typingChannel]="post?.id ? 'typing_comments:' + post.id : null" style="width: 100%" (submitted)="onReplySubmit($event, post, comment)"
                          [imageOnly]="true" [allowEmptySubmit]="true"
                          [label]="getReplyInputLabel(comment)"></app-social-input>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </ng-container>
          <ng-container *ngIf="!comments.length && commentBoxLoaded">
            <div class="social-comments-empty">
              <i class="pi pi-comments social-comments-empty__icon"></i>
              <div class="social-comments-empty__title">{{ 'common.no_comments_yet' | translate }}</div>
              <div class="social-comments-empty__subtitle">{{ 'common.write_first_comment' | translate }}</div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-template>
</p-card>
</div>
</ng-template>
